import { CONST } from "./const";

type LogLevel = "log" | "error" | "warn" | "info";

class Logger {
  private enabled: boolean;

  constructor() {
    const environment = !CONST.IS_DEV;

    switch (environment) {
      case true:
        this.enabled = false; // Disable logging in production
        break;
      case false:
        this.enabled = true; // Enable limited logging in staging
        break;
      default:
        this.enabled = true; // Enable logging in other environments
    }
  }

  public setLogging(enabled: boolean) {
    this.enabled = enabled;
  }

  public log(level: LogLevel, ...args: any[]) {
    if (this.enabled) {
      console[level](...args);
    }
  }

  public debug(...args: any[]) {
    this.log("log", ...args);
  }

  public error(...args: any[]) {
    this.log("error", ...args);
  }

  public warn(...args: any[]) {
    this.log("warn", ...args);
  }

  public info(...args: any[]) {
    this.log("info", ...args);
  }
}

const logger = new Logger();
export default logger;
